import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment.production";

export function initializeKeycloak(keycloak: KeycloakService) {
    return () => {
      stripUnsolicitedAuthResponse();
      return keycloak.init({
        config: environment.keyCloakConfig,
        initOptions: environment.keyCloakInitOptions
      });
    };
  }

function stripUnsolicitedAuthResponse() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('code')) {
    return;
  }
  ['code', 'session_state', 'iss', 'state'].forEach(param => url.searchParams.delete(param));
  history.replaceState(history.state, '', url);
}
